<!--
    描述： 投资计算.vue
    创建时间： 2022-08-29 17:23:16
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
	<w-split v-model="splitV" class="h100 current-layout">
		<div class="w-strucutre-layout" slot="left">
			<div class="w-strucutre-header">
				<div class="left-text">
					<el-tag>项目结构树</el-tag>
				</div>
				
				<div class="btnGroups">
					<el-button size="small" type="warning" @click="handleLock">{{ showEdit ? '锁定' : '解锁' }}
					<!-- <el-button size="small" type="warning" @click="showEdit = !showEdit">{{ showEdit ? '锁定' : '解锁' }} -->
					</el-button>
					<el-button size="small" :loading="pageLoading" type="primary" @click.stop.prevent="doSave()">保存
					</el-button>
				</div>
			</div>
			<div class="w-structure-content">
				<div class="left-tree-layout">
					<el-tree
  					  	ref="xTree"
  					  	:data="treeData"
  					  	node-key="id"
  					  	:show-checkbox="showEdit"
  					  	default-expand-all
  					  	:default-checked-keys="defaultChecked"
  					  	:expand-on-click-node="false"
  					  	@check="onCheckChange"
  					 >
  					 	<div class="custom-tree-node" slot-scope="{ node, data }">
  					 		<el-input 
  					 			size="mini" 
  					 			v-model="data.sname" 
  					 			class="custom-input"
  					 			:disabled="data.level === 0"
  					 			autofocus
  					 			@focus="onInputFocus(node, data)"
  					 			@input="onInputSname($event, node, data)"
  					 		></el-input>
  					 		<span class="custom-text" v-if="data.level === 0">合计： {{ getTotal(data.type) + ' ' + unitName }}</span>
  					 		<span class="custom-button" v-show="showEdit">
  					  		   	 <el-button
  					  		   	    type="text"
  					  		   	    size="mini"
  					  		   	    icon="el-icon-plus"
  					  		   	    :disabled="data.level >= 5"
  					  		   	    @click.stop="handleClickNode('add', node, data)">
  					  		   	</el-button>
  					  		   	<el-button
  					  		   	    type="text"
  					  		   	    size="mini"
  					  		   	    icon="el-icon-delete"
  					  		   	   	:disabled="data.level === 0 || (data.children && data.children.length > 0)"
  					  		   	    @click.stop="handleClickNode('delete', node, data)">
  					  		   	</el-button>
  					  		</span>
  					 		<!-- <p>{{ data.sname }}</p> -->
  					 	</div>
  					</el-tree>
				</div>
  			</div>
		</div>
		<div class="w-strucutre-layout right-table-layout" slot="right">
			<div class="w-strucutre-header">
				<div class="left-text">项目投资概算表 (单位: {{ unitName }})</div>
				<div class="right-btn">
					<div class="select-box" v-show="!showTableEdit">
						单位：
						<el-select v-model="curUnit" size="small" @change="handleChangeUnit">
							<el-option :value="0" label="元"></el-option>
							<el-option :value="1" label="万元"></el-option>
							<el-option :value="2" label="亿元"></el-option>
						</el-select>
					</div>
					<el-button size="small" type="primary" @click.stop.prevent="handleTableEdit">{{ showTableEdit ? '锁定' : '解锁' }}
					</el-button>
					<el-button size="small" :loading="pageLoading" type="primary" @click.stop.prevent="doSave()">保存
					</el-button>
				</div>
			</div>

			<div class="w-structure-content">
				<div class="h100">
					<vxe-table 
						border 
						height="99%"
						size="mini"
						keep-source
						show-overflow 
						show-footer
						resizable 
						auto-resize
						ref="xTable" 
						header-align="center"
						highlight-current-row
						:keyboard-config="{isEnter: true}"
						row-id="id" 
						:data="tableObj.listData"
						:loading="tableObj.loading" 
						:edit-config="tableObj.editConfig" 
						:tree-config="tableObj.treeConfig" 
						:footer-method="footerMethod"
						:footer-cell-class-name="footerCellClassName"
					>
						<vxe-table-column field="treeIndex" title="序号" width="90" tree-node ></vxe-table-column>
						<vxe-table-column field="sname" title="项目名称" min-width="210" ></vxe-table-column>
						<vxe-table-column 
							:class-name="cellClassName" 
							field="buildingCost" 
							title="建筑工程费用" 
							width="130" 
							:cell-render="{name: 'number-input--default', events: { change: onValueChange }, attrs: { showTableEdit: showTableEdit, unit: curUnit }}" 
							align="right"
							header-align="center"
						>
							<!-- 表尾合计实时更新 -->
							<template v-slot:footer="{$rowIndex}">
				              	<span v-if="$rowIndex === 0">{{ getColumnSum('buildingCost') }}</span>
				            </template>
						</vxe-table-column>
						<vxe-table-column 
							:class-name="cellClassName" 
							field="installCost" 
							title="安装工程费用" 
							width="130" 
							:cell-render="{name: 'number-input--default', events: { change: onValueChange }, attrs: { showTableEdit: showTableEdit, unit: curUnit }}" 
							align="right"
							header-align="center"
						>
							<!-- 表尾合计实时更新 -->
							<template v-slot:footer="{$rowIndex}">
				              	<span v-if="$rowIndex === 0">{{ getColumnSum('installCost') }}</span>
				            </template>
						</vxe-table-column>
						<vxe-table-column 
							:class-name="cellClassName"
							field="deviceCost"
							title="设备购置费"
							width="125"
							:cell-render="{name: 'number-input--default', events: { change: onValueChange }, attrs: { showTableEdit: showTableEdit, unit: curUnit }}"
							align="right"
							header-align="center"
						>
							<!-- 表尾合计实时更新 -->
							<template v-slot:footer="{$rowIndex}">
				              	<span v-if="$rowIndex === 0">{{ getColumnSum('deviceCost') }}</span>
				            </template>
						</vxe-table-column>
						<vxe-table-column
							:class-name="cellClassName" 
							field="otherCost" 
							title="其他费用"
							width="160"
							:cell-render="{name: 'number-input--default', events: { change: onValueChange, perChange: onPercentChange }, attrs: { showTableEdit: showTableEdit, unit: curUnit }}"
							align="right"
							header-align="center"
						>
							<!-- 表尾合计实时更新 -->
							<template v-slot:footer="{$rowIndex}">
				              	<span v-if="$rowIndex === 0">{{ getColumnSum('otherCost') }}</span>
				            </template>
						</vxe-table-column>
						<vxe-table-column title="合计" width="130" align="right" header-align="center">
							<template v-slot="{ row }">
              					<span>{{ countAmount(row) }}</span>
            				</template>
            				<!-- 表尾合计实时更新 -->
							<template v-slot:footer="{$rowIndex}">
				              	<span v-if="$rowIndex === 0">{{ getColumnSum('totalCost') }}</span>
				            </template>
						</vxe-table-column>
						<vxe-table-colgroup title="技术经济指标">
							<vxe-table-column
								:class-name="cellClassName"
								field="unit"
								title="单位"
								width="90"
								align="center"
							>
								<template v-slot="{ row }">
									<vxe-input v-model="row.unit" v-show="showTableEdit"></vxe-input>
									<span v-show="!showTableEdit">{{ row.unit }}</span>
								</template>
								<!-- 表尾可编辑 -->
								<template v-slot:footer="{$rowIndex}">
									<template v-if="$rowIndex === 0">
										<vxe-input 
                							v-show="showTableEdit"
      										class="w-number-input" 
      										type="float" 
      										v-model="investUnit"
                						    digits="2"
      										maxlength="16"
                						    min="0"
      										:controls="false"
      									></vxe-input>
      									<span v-show="!showTableEdit">{{ investUnit }}</span>
									</template>
				            	</template>
							</vxe-table-column>
                			<vxe-table-column 
                				:class-name="cellClassName"
                				field="quantity" 
                				title="工程量" 
                				width="100" 
                				align="right"
								header-align="center"
                			>
                				<template v-slot="{ row }">
                					<vxe-input 
                						v-show="showTableEdit"
      									class="w-number-input" 
      									type="float" 
      									v-model="row.quantity"
                					    digits="2"
      									maxlength="16"
                					    min="0"
      									:controls="false"
      								></vxe-input>
      								<span v-show="!showTableEdit">{{ row.quantity }}</span>
                				</template>
                				<!-- 表尾可编辑 -->
								<template v-slot:footer="{$rowIndex}">
									<template v-if="$rowIndex === 0">
										<vxe-input 
                							v-show="showTableEdit"
      										class="w-number-input" 
      										type="float" 
      										v-model="investQuantity"
                						    digits="2"
      										maxlength="16"
                						    min="0"
      										:controls="false"
      									></vxe-input>
      									<span v-show="!showTableEdit">{{ investQuantity }}</span>
									</template>
				            	</template>
                			</vxe-table-column>
                			<vxe-table-column field="price" title="造价指标(元)" width="120" align="right" header-align="center">
                				<template v-slot="{ row }">
              						<span>{{ countPrice(row) }}</span>
            					</template>
            					<!-- 表尾 -->
								<template v-slot:footer="{$rowIndex}">
									<span>{{ countFooterPrice }}</span>
								</template>
                			</vxe-table-column>
						</vxe-table-colgroup>
						<vxe-table-column field="rate" title="比例(%)" width="90" align="right" header-align="center">
							<template v-slot="{ row }">
              					<span>{{ countRate(row) }} %</span>
            				</template>
						</vxe-table-column>
						<vxe-table-column :class-name="cellClassName"  field="remark" title="备注" width="150" align="right" header-align="center">
							<template v-slot="{ row }">
              					<vxe-input v-model="row.remark" v-show="showTableEdit"></vxe-input>
									<span v-show="!showTableEdit">{{ row.remark }}</span>
            				</template>
						</vxe-table-column>
					</vxe-table>
				</div>
			</div>
		</div>
	</w-split>
</template>

<script>
// api
import * as Api from '@/api/modules/analysisInvest.js'

export default {
	data() {
		return {
			splitV: 0.25,
			curUnit: 1,
			unitName: '万元',
			fixedNum: 4,
			// 树原始数据
			treeData: [],
			defaultChecked: [],
			checkedKeys: [],
			checkedNodes: [],
			isFirst: false,
			showEdit: false,	// 是否开启编辑
			// 表格相关 
			pageLoading: false,
			showTableEdit: false,
			tableObj: {
				loading: false,
				// 数据源
				listData: [],
				// 编辑配置
				editConfig: {
					trigger: 'click', 
					mode: 'cell', 
					showStatus: true,
					activeMethod: (obj) => { 
						return this.IsCellEdit(obj)
					}
				},
				// 树形结构配置
				treeConfig: {
					lazy: true, 
					indent: 10,	// 树节点的缩进 
					children: 'children', 
					hasChild: 'hasChild', 
					// loadMethod: loadChildrenMethod, 
					accordion: false,
					expandAll: true
				}
			},
			// 建设投资合计行  可编辑字段
			investQuantity: '',
			investUnit: '',
			// 保存定时器
			saveInterval: null
		}
	},
	created() {
		// 初次赋值
		this.isFirst = true
		this.getPageInfo()

		let time = 1000 * 60 * 30
		this.saveInterval = setInterval(() => {
			this.doSave('hideMessage')
		}, time)
	},
	methods: {
		// 获取页面数据
		getPageInfo() {
			Api.getNodeInfo({ projectId: this.curProjectId })
				.then(res => {
					this.renderData(res.data)
				})
				.catch(err => {})
		},

		// 渲染初始数据
		renderData(resData) {
			this.treeData = resData && resData.length > 0 ? resData : []
			let checkedArr = this.$utils.filterTree(this.treeData, x => x.isChecked === 1 || (x.children && x.children.find(y => y.isChecked === 1)))
			this.checkedNodes = checkedArr
			this.checkedKeys = checkedArr.map(x => x.id)

			// 筛选出 半选的 节点
			let _isCheckNodes = checkedArr.filter(x => !x.children || !x.children.find(y => y.isChecked === 0))


			this.$nextTick(() => {
				this.$refs.xTree.setCheckedNodes(_isCheckNodes)
			})

			// 处理表格数据
			setTimeout(() => {
				this.updateTable()
			}, 100)
		},

		// 获取左侧树结构数据
		getTreeData() {
			console.log(this.treeData)
			console.log(this.$refs.xTree)
		},

		// 处理数据
		loadChildrenMethod ({ row }) {
          // 异步加载子节点
          // return XEAjax.get('/api/file/node/list', { parentId: row.id })
        },

        // 切换单位
        handleChangeUnit(val) {
        	let nameArr = ['元', '万元', '亿元']
        	this.curUnit = val
        	this.unitName = nameArr[val]
        	this.fixedNum = [2,4,5][val]

        	this.$refs.xTable.refreshColumn()
        	this.$refs.xTable.updateData()

        	this.updateTable()
        },

        // 左侧树是否锁定
        handleLock() {
        	this.showEdit = !this.showEdit

        	if (!this.showEdit) {
        		this.doSave()
        	}
        },

        // 表格是否锁定
        handleTableEdit() {
        	this.handleChangeUnit(1)
        	this.showTableEdit = !this.showTableEdit

        	if (!this.showTableEdit) {
        		this.doSave()
        	}
        },
        
        // 金额展示
        dealShowValue(value) {
        	let showValue = ''
        	switch (this.curUnit) {
        		case 0:
        			showValue = parseFloat(this.$utils.multiply(value, 10000)).toFixed(2)
        			break;
        		case 1:
        			showValue = parseFloat(value).toFixed(4)
        			break;
        		case 2:
        			showValue = parseFloat(this.$utils.divide(value, 10000)).toFixed(6)
        			break
        	}
        	// return row[column.property] ? parseFloat(row[column.property]).toFixed(fixedNum) : ''
        	return showValue
        },

        /********** 左侧树模块 ***********/
        // 树check 选择事件
        onCheckChange(data, nodeObj) {
        	this.isReload = true
        	data.isChecked = data.isChecked === 1 ? 0 : 1
        	let curData = data

        	// 重新赋值选中数组
        	this.checkedNodes = [...nodeObj.checkedNodes, ...nodeObj.halfCheckedNodes]
        	this.checkedKeys = [...nodeObj.checkedKeys, ...nodeObj.halfCheckedKeys]

        	// 处理父子节点的 isChecked
        	this.$utils.mapTree(this.checkedNodes, x=> {
        		x.isChecked = 0
        	})
        	this.checkedNodes.map(x => {
        		x.isChecked = 1
        	})

        	// 更新表格
        	setTimeout(() => {
				this.updateTable(curData)
			}, 100)
        },
        // 点击树节点 新增、删除
        handleClickNode(type, node, data) {
        	let node_children = data.children
        	let node_children_length = node_children.length
        	let node_parent = node.level === 0 ? null : node.parent.data
        	let node_parent_children = node_parent ? node_parent.children : []
        	let curData = data

        	switch (type) {
        		// 新增
        		case 'add':
        			let sort = node_children_length + 1
        			let newChild = {
        			  	level: parseInt(data.level) + 1,
        			  	sortIndex: data.sortIndex + '.' + sort,
        			  	treeIndex: data.treeIndex + '.' + sort,
        			  	id: this.Snowflake.nextId(),
        			  	pid: data.id,
        			  	type: data.type,
        			  	sname: '',
        			  	buildingCost: '',
        			  	installCost: '',
        			  	deviceCost: '',
        			  	otherCost: '',
        			  	totalCost: '',
        			  	unit: '',
        			  	quantity: '',
        			  	price: '',
        			  	rate: '',
        			  	children: [],
        			  	isChecked: 1
        			}
			
        			data.children.push(newChild)

        			// this.checkedNodes
        			setTimeout(() => {
        				this.$refs.xTree.setChecked(newChild.id, true)
        			})
        			break
        		// 删除
        		case 'delete':
        			// (二次判断 双重保险) 如果是一级目录
        			if (node.level === 0) {
        				this.$message.warning('该结构层级不能删除！')
        				return
        			}

        			// (二次判断 双重保险) 如果是一级目录
        			if (node_children && node_children_length > 0) {
        				this.$message.warning('该结构下有子节点, 无法删除！')
        				return
        			}

        			// 删除节点时  触发更新
        			this.$refs.xTree.remove(node)
        			// let checkedNodes = this.$refs.xTree.getCheckedNodes()
        			// let checkedKeys = this.$refs.xTree.getCheckedKeys()
        			// let halfCheckedNodes = this.$refs.xTree.getHalfCheckedNodes()
        			// let halfCheckedKeys = this.$refs.xTree.getHalfCheckedKeys()

        			// this.checkedNodes = [...checkedNodes, ...halfCheckedNodes]
        			// this.checkedKeys = [...checkedKeys, ...halfCheckedKeys]

        			// 重新排序
        			// node_parent_children.map((item, index) => {
        			// 	item.sortIndex = node_parent.sortIndex + '.' + (index + 1)
        			// 	item.treeIndex = node_parent.treeIndex + '.' + (index + 1)
        			// })

        			break
        	}

        	// 更新表格
        	setTimeout(() => {
        		// 树 触发更新
        		let checkedNodes = this.$refs.xTree.getCheckedNodes()
        		let checkedKeys = this.$refs.xTree.getCheckedKeys()
        		let halfCheckedNodes = this.$refs.xTree.getHalfCheckedNodes()
        		let halfCheckedKeys = this.$refs.xTree.getHalfCheckedKeys()

        		this.checkedNodes = [...checkedNodes, ...halfCheckedNodes]
        		this.checkedKeys = [...checkedKeys, ...halfCheckedKeys]

				this.updateTable(curData)
			}, 300)
        },
        // 点击输入框事件
        onInputFocus(node, data) {
        	let itemObj = this.$utils.findTree(this.tableObj.listData, x => x.id === data.id)

        	if (itemObj && itemObj.item) {
        		// 滚动到对应位置并高亮
        		this.$refs.xTable.scrollToRow(itemObj.item)
        		this.$refs.xTable.setCurrentRow(itemObj.item)
        	}
        },
        // 输入框改变名字事件
        onInputSname(val, node, data) {
        	let itemObj = this.$utils.findTree(this.tableObj.listData, x => x.id === data.id)
        	if (itemObj && itemObj.item) {
        		itemObj.item.sname = val
        	}
        },
        // 左侧树 =》 改变右侧表格
        updateTable(row) {
        	// 取得源数据 (如果是初次加载  取树节点数据， 否则取现有的表格 作为 源数据)
        	let arr = this.isFirst ? JSON.parse(JSON.stringify(this.treeData)) : this.$utils.clone(this.tableObj.listData, true)
        	// 关闭当前状态参数
			this.isFirst = false

			// 源数据 转化为 一维数组
			let _treeList = this.$utils.toTreeArray(JSON.parse(JSON.stringify(this.treeData)))
			let _listData = this.$utils.toTreeArray(arr)

			

        	// 根据选中的节点 将新增的选中节点 添加到 源数据中 (保持和树结构 同样的顺序)
        	_treeList.map((x, index) => {
				let _item = _listData.find(y => y.id === x.id)

				// 如果树节点存在  而表格不存在 则添加
				if (!_item) {
					_listData.splice(index, 0, this.$utils.clone(x))
				}
			})


			// 再过滤掉 未被选中的 但仍存在表格中的
			_listData = _listData.filter(x => this.checkedKeys.includes(x.id))

        	// 处理成树结构
			let _tableList = this.$utils.toArrayTree(_listData, {parentKey: 'pid'})

			// 处理排序问题
			_tableList = this.dealSort(_tableList)

			setTimeout(() => {
				this.tableObj.listData = _tableList
				this.$refs.xTable.loadData(_tableList)
				this.$refs.xTable.setAllTreeExpand(true)

				// 重新计算
				row ? this.countChildren(row) : ''
			})
        },
        // 展示合计
        getTotal(type) {
        	let item = this.tableObj.listData.find(x => x.type === type)
			return item ? this.dealShowValue(item.totalCost) : 0
        },


        /********** 右侧表格模块 ***********/
        // 列样式
        cellClassName({row, column}) {
      		let editColumn = ['unit', 'quantity', 'otherCost', 'remark']
      		let disabledRow = ['investCost', 'secondCost', 'reserveCost']
      		let noChildren = row.children && row.children.length === 0

      		// 可编辑的单元格
      		let requestCell = !disabledRow.includes(row.type) || editColumn.includes(column.property)

      		// 锁定状态下 不需要背景色
      		if (!this.showTableEdit) return ''

      		// 可编辑行
        	if ((requestCell && noChildren) || ['quantity', 'unit', 'remark'].includes(column.property)) {
        		if (column.property === 'unit') return ['center-cell', 'edit-cell']
        		return ['edit-cell']
        	}

        	return ''
        },
        // 表尾样式
        footerCellClassName({ column, columnIndex, $rowIndex }) {
        	switch (column.property) {
        		case 'sname':
        			return ''
        			break
        		case 'unit':
        			return $rowIndex === 0 && this.showTableEdit ? 'edit-cell' : ''
        		case 'quantity':
        			return $rowIndex === 0 && this.showTableEdit ? 'edit-cell' : ''
        		default:
        			return 'bg-color-blue'
        	}
        },
        // 表格单元格是否可编辑
        IsCellEdit({row, rowIndex, column, columnIndex}) {
        	let noChildren = row.children && row.children.length === 0
        	let otherCost = column.property === 'otherCost'

        	let condition1 = noChildren && otherCost
        	return row.isEdit || condition1
        },
        // 表尾数据渲染
        footerMethod({ columns, data }) {
        	let sumArr = [], rateArr = []
        	columns.forEach((column, columnIndex) => {
        		switch (column.property) {
        			// 序号
        			// case 'sortIndex':
        			// 	sumArr.push('')
        			// 	rateArr.push('')
        			// 	break
        			// 名称
        			case 'sname':
        				sumArr.push('建设投资合计')
        				rateArr.push('比例(%)')
        				break
        			// 合计
        			case 'totalCost':
        				sumArr.push('')
        				rateArr.push('')
        				break
        			// 比例
        			case 'rate':
        				sumArr.push('100.00 %')
        				rateArr.push('100.00 %')
        				break
        			default:
        				sumArr.push('')
        				rateArr.push('')
        		}
        	})

        	return [ sumArr, rateArr ]
        },

        // 处理表格排序
        dealSort(list, parentSort) {
        	list.map((x, index) => {
        		// 排序
        		x.treeIndex = x.level === 0 ? (index + 1) : parentSort + '.' + (index + 1)

        		if (x.children && x.children.length > 0) this.dealSort(x.children, x.treeIndex)
        	})

        	return list
        },
        // 单元格值改变事件
        onValueChange({row, column}) {
        	// 递归累加
        	this.deepSum(row, column)

        	// 计算总费用有延迟 加个定时器
        	setTimeout(() => {
        		// 计算工程预备费（百分比）
        		let item = this.tableObj.listData.find(x => x.type === 'reserveCost')
	
        		if (item && item.children) {
        			item.children.map(x => {
        				this.onPercentChange({row: x, column})
        			})
        		}
        	}, 500)
        },
        // 百分比变化时触发事件
        onPercentChange({ row, column }) {
        	let item1 = this.tableObj.listData.find(x => x.type === 'projectCost') || {totalCost: null}
        	let item2 = this.tableObj.listData.find(x => x.type === 'secondCost') || {totalCost: null}
        	let arr = [item1.totalCost, item2.totalCost]
        	let baseTotal = this.$utils.sum(arr)

        	this.$set(row, 'otherCost', this.$utils.multiply(baseTotal, row.otherCostRate) / 100)
        	this.updateTree(row)

        	this.deepSum(row, {property: 'otherCost'})
        },
        // 递归累加
        deepSum(row, column) {
        	let _parentObj = this.$utils.findTree(this.tableObj.listData, x => x.id === row.pid)
        	let _parent = _parentObj ? _parentObj.item : null

        	if (_parent) {
        		this.$set(_parent, column.property, this.$utils.sum(_parent.children, column.property))
        		// this.updateTree(row)

        		this.deepSum(_parent, column)
        	}
        },
        // 合计 (建筑、安装、设备、其它)
        countAmount(row) {
        	this.$set(row, 'totalCost', this.$utils.sum([row.buildingCost, row.installCost, row.deviceCost, row.otherCost]))
        	this.updateTree(row)
        	return this.dealShowValue(row.totalCost)
        },
        // 计算单价 = 合计总价 / 工程量
        countPrice(row) {
        	// 数据库保存的是万元
        	let total = parseFloat(this.$utils.multiply(row.totalCost, 10000)).toFixed(2)

        	let _price = row.quantity && parseFloat(row.quantity) !== 0 ? this.$utils.divide(total, row.quantity).toFixed(2) : null
        	this.$set(row, 'price', _price)
        	this.updateTree(row)
        	return row.price
        },
        // 计算比例 = 当前合计 / 全部合计
        countRate(row) {
        	let _baseTotal = this.$utils.sum(this.tableObj.listData, 'totalCost')
        	let _rate = _baseTotal && parseFloat(_baseTotal) !== 0 ? this.$utils.divide(row.totalCost, _baseTotal) : null
        	this.$set(row, 'rate', this.$utils.multiply(_rate, 100).toFixed(2))
        	this.updateTree(row)

        	return row.rate
        },
        // 重新计算子级汇总
        countChildren(data) {
        	let itemObj = this.$utils.findTree(this.tableObj.listData, x => x.id === data.id)
        	// console.log(itemObj)
        	let row = itemObj && itemObj.item || {}
        	if (row && row.children) {
        		let buildingCost = this.$utils.sum(row.children, 'buildingCost')
        		let installCost = this.$utils.sum(row.children, 'installCost')
        		let deviceCost = this.$utils.sum(row.children, 'deviceCost')
        		let otherCost = this.$utils.sum(row.children, 'otherCost')

        		this.$set(row, 'buildingCost', buildingCost)
        		this.$set(row, 'installCost', installCost)
        		this.$set(row, 'deviceCost', deviceCost)
        		this.$set(row, 'otherCost', otherCost)

        		this.countAmount(row) 
        		this.countPrice(row) 
        		this.countRate(row) 
        	}

        	let parent = this.$utils.findTree(this.treeData, x => x.id === data.pid)
        	if (parent && parent.item) {
        		this.countChildren(parent.item)
        	}
        },

        // 右侧表格表格数据变化时 =》 更新左侧 tree
        updateTree(row) {},

        // 表位列合计
        getColumnSum(column) {
        	// let item = this.tableObj.listData.find(x => x.type === 'projectCost')
        	let sum = this.$utils.sum(this.tableObj.listData, column)
			return sum ? this.dealShowValue(sum) : this.dealShowValue(0)
        },

        // 点击保存
        doSave(hideMessage) {
        	if (!this.curProjectId || this.curProjectId === '') {

        		if (this.saveInterval) {
					clearInterval(this.saveInterval)
				}
        		return
        	}
        	this.pageLoading = true
        	this.tableObj.loading = true

        	/* 以左侧树为 大数组，右边表格为小数组。 
        	 * 小数组有的 以小数组数据为主
        	 * 小数组没有的 以大数组数据为主
        	 * 合并数组
        	 * **/

        	let sumArr = []
        	let originalList = this.$utils.clone(this.tableObj.listData, true)

        	this.$utils.eachTree(this.treeData, x => {
        		let _tableItem = this.$utils.findTree(originalList, y => y.id === x.id)

        		if (_tableItem && _tableItem.item) {
        			sumArr.push(_tableItem.item)
        		} else {
        			sumArr.push(x)
        		}
        	})

        	// 转化为 树结构
        	let backArr = this.$utils.toArrayTree(sumArr, {parentKey: 'pid'})
        	// console.log(backArr)

        	Api.saveInvest({
        		projectId: this.curProjectId,
        		list: backArr
        	})
        		.then(res => {
        			if (!hideMessage) {
        				this.$message.success('保存成功')
        			}
        			setTimeout(() => {
        				this.pageLoading = false
        				this.tableObj.loading = false
        			}, 2000)
        		})
        		.catch(err => {
        			setTimeout(() => {
        				this.pageLoading = false
        				this.tableObj.loading = false
        			}, 2000)
        		})
        }
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId
		},

		// 工程费用合计
		projectCostSum() {
			let item = this.tableObj.listData.find(x => x.type === 'projectCost')
			return item ? this.dealShowValue(item.totalCost) : this.dealShowValue(0)
		},

		// 二类费用合计
		secondCostSum() {
			let item = this.tableObj.listData.find(x => x.type === 'secondCost')
			return item ? this.dealShowValue(item.totalCost) : this.dealShowValue(0)
		},

		// 工程预备费合计
		reserveCostSum() {
			let item = this.tableObj.listData.find(x => x.type === 'reserveCost')
			return item ? this.dealShowValue(item.totalCost) : this.dealShowValue(0)
		},

		// 建设投资合计单价计算
		countFooterPrice() {
			let total = this.getColumnSum('totalCost')

			let _price = this.investQuantity && parseFloat(this.investQuantity) !== 0 ? this.$utils.divide(total, this.investQuantity).toFixed(2) : null
			return _price
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.saveInterval) {
			clearInterval(this.saveInterval)
		}

		next()
	}
}

</script>

<style lang="less" scoped>
.current-layout {
	// 左侧树
	.left-tree-layout {
    	width: 100%;
    	height: 100%;
    	overflow: auto;

    	/deep/ .el-tree {
    		width: fit-content;
    		min-width: 100%;
    	}
	}

	/deep/ .el-tree-node__content {
		height: 28px;
	}

	/deep/ .el-tree > .el-tree-node > .el-tree-node__content {
		background-color: #ceebfb;
	}

	/deep/ .vxe-table--render-default .vxe-tree-cell {
		padding-left: 18px;
	}

	.custom-tree-node {
		flex: 1;
		font-size: 14px;
		display: flex;

		.custom-input {
			flex: 1;
		}

		.custom-text {
			line-height: 28px;
			padding-right: 10px;
		}

		.custom-button {
			padding: 0 7px;
		}

		/deep/ .el-input__inner {
			border: none;
    		background-color: transparent;
    		font-size: 14px;
    		width: fit-content;
    		min-width: 100%;
		}
	}

	// 右侧表格样式
	.right-table-layout {
		z-index: 1;
    	background-color: #fff;

    	.right-btn {
    		display: flex;
    		align-items: center;
    		overflow: hidden;
    		white-space: nowrap;
    	}

    	.select-box {
    		display: flex;
    		width: 150px;
    		margin-right: 10px;
    		align-items: center;
    	}
	}

	/deep/ .vxe-table--body-wrapper {
		.vxe-cell {
			padding: 0 5px;
			font-size: 14px;
		}

		.vxe-input--inner {
			border: none !important;
			background-color: transparent;
			text-align: right;
			padding: 0;
		}

		.edit-cell {
			background-color: #fffde7;
		}

		.show-cell-text {
			color: #606266;
			font-size: 14px;
		}

		// 百分比输入框
		.percent-flex {
			display: flex;
	
			.percent-input {
				width: 50%;
    			height: 35px;
    			padding-right: 20px;
    			position: absolute;
    			left: 0;
    			top: 0;
    			bottom: 0px;
    			background-color: #d8ffff;
			}

			.percent-icon {
				position: absolute;
				right: 54%;
    			top: 5px;
    			color: #fb4d4d;
			}
	
			.percent-span {
    			position: absolute;
    			right: 1px;
    			bottom: 1px;
    			top: 0;
    			width: 50%;
				background-color: #fff;
				line-height: 34px;
    			padding-right: 10px;
			}
		}

		// 居中输入框
		.center-cell .vxe-input--inner {
			text-align: center;
		}
	}

	/deep/ .vxe-table--footer-wrapper {
		.vxe-cell {
			padding: 0 5px;
			font-size: 14px;
		}

		.vxe-input--inner {
			border: none !important;
			background-color: transparent;
			text-align: right;
			padding: 0;
		}

		.edit-cell {
			background-color: #fffde7;
		}
	}

	.bg-color-blue {
		background-color: #d8ffff;
	}
}
</style>
